<template>
  <form class="ONE-TIME-CODE-FORM p-2" @submit.prevent="submit">
    <div class="h4 text-bold m-b-1">
      Sign In With Contact Info
    </div>
    <div class="d-flex fd-column ai-center">
      <div class="TEXT-AREA">
        <div v-if="isEmail" class="m-b-3 INSTRUCTION-TEXT as-start" >
          Your code has been sent to
          <span class="text-bold">{{sentTo}}</span>
          ! Use it to sign in below.
        </div>
        <div v-else class="m-b-3 INSTRUCTION-TEXT" >
          Your code has been texted to
          <span class="text-bold as-start">{{sentTo}}</span>
          ! User it to sign in below.
        </div>
        <div class="m-b-1 INSTRUCTION-TEXT as-start" v-html="timeLeft">
        </div>
      </div>
      <div class="d-flex fd-row p-b-2">
        <v-otp-input
            ref="otpInput"
            input-classes="otp-input"
            separator=""
            :num-inputs="6"
            :should-auto-focus="true"
            :is-input-num="true"
            @on-change="handleOnChange"
            @on-complete="handleOnComplete"
        />
      </div>
      <div v-if="hasError" class="c-red m-b-1">
        <vk-icon name="exclamation" class="ERROR-ICON m-r-1"/>{{ errorMessage }}
      </div>
      <a
          @click.prevent="onSendAnotherClick"
          class="link m-b-3"
      >
        Send me another code
      </a>
    </div>
    <button
        :disabled="disabled"
        type="submit"
        class="btn w-100 m-b-2"
    >
      Sign In With One-Time Code
    </button>
  </form>
</template>

<script>
import OtpInput from '@bachdgvn/vue-otp-input';

export default {
  name: 'one-time-code-sign-in-form',
  components: {
    'v-otp-input': OtpInput,
  },
  data () {
    return {
      userToken: '',
      loading: false,
      accounts: [],
      endTime: 0,
      currentTimeLeft: 900000,
      lengthOfTimer: 900000,
      redirectTo: '',
      loginId: '',
      hasError: false,
      sentTo: '',
      numberOfAttempts: 0,
    };
  },
  computed: {
    ACTIVEINPUTWRAPPER () {
      return {
        margin: '16px',
        border: '2px solid #FFA500',
        color: 'red',
      };
    },
    email () {
      return this.isEmail ? this.sentTo : '';
    },
    timeLeft () {
      let minutes = Math.floor((this.currentTimeLeft % (1000 * 60 * 60)) / (1000 * 60));
      if (minutes > 10) {
        minutes = (`0${minutes}`).slice(-2);
      }
      let seconds = Math.floor((this.currentTimeLeft % (1000 * 60)) / 1000);
      if (seconds < 10) {
        seconds = (`0${seconds}`).slice(-2);
      }
      const timeLeft = this.currentTimeLeft > 0 ? `${minutes} : ${seconds}` : '<span class="text-bold">Expired</span>';
      return `One Time Code ${timeLeft}`;
    },
    isEmail () {
      return this.sentTo.split('').includes('@');
    },
    disabled () {
      return this.loading || this.hasError || this.userToken.length < 6;
    },
    outOfAttempts () {
      return this.numberOfAttempts > 2;
    },
    errorMessage () {
      return this.outOfAttempts ? 'You have reached maximum number of attempts, please try again.' : 'The code didn’t match. Try Again.';
    },
  },

  mounted () {
    if (!this.$route.params.timeStarted) {
      this.$router.go(-1);
    }
    this.sentTo = this.$route.params.sentTo;
    this.loginId = this.$route.params.loginId;
    this.timeStarted = this.$route.params.timeStarted;
    this.redirectTo = this.$route.params.redirectTo;
    this.timer();
  },
  methods: {
    timer () {
      this.endTime = Number(this.timeStarted) + this.lengthOfTimer;
      if (this.currentTimeLeft > 0) {
        setInterval(() => {
          const now = new Date().getTime();
          this.currentTimeLeft = this.endTime - now;
        }, 1000);
      }
    },
    async submit () {
      try {
        this.loading = true;
        await this.$store.dispatch('user/login', {
          username: this.loginId,
          password: this.userToken,
          type: 'one_time_login',
        });
        this.$events.$emit(this.$events.OTC_ENTER_CLICK);
        this.loading = false;
        this.redirect();
      } catch (err) {
        this.$events.$emit(this.$events.OTC_ENTER_CLICK_ERROR);
        this.loading = false;
        this.handleClearInput();
        this.hasError = true;
        this.numberOfAttempts += 1;
      }
    },
    redirect () {
      this.$router.push({
        name: 'create-a-password',
        query: {
          redirectTo: this.redirectTo,
        },
      });
    },
    onSendAnotherClick () {
      this.$router.push({
        name: 'one-time-code',
        query: {
          redirectTo: this.redirectTo,
        },
      });
      this.$events.$emit(this.$events.OTC_SEND_ANOTHER_CODE_CLICK);
    },
    handleOnComplete (value) {
      this.userToken = value;
    },
    handleOnChange (value) {
      if (!this.outOfAttempts) {
        this.userToken = value;
        this.hasError = false;
      }
    },
    handleClearInput () {
      this.$refs.otpInput.clearInput();
      this.userToken = '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools.scss";

.ONE-TIME-CODE-FORM {
  @include responsive(width, 100%, 630px);
}
.INSTRUCTION-TEXT {
  font-size: 14px;
}
.TEXT-AREA {
  display: flex;
  flex-direction: column;
  @include responsive(width, 100%, 500px);
}
/deep/.otp-input {
    width: 40px;
    height: 40px;
    padding: 5px;
    margin: 0 10px;
    font-size: 20px;
    border-radius: 0px;
    border: 1px solid rgba(0, 0, 0, 0.3);
    text-align: center;
    &.error {
      border: 1px solid red !important;
    }
   &:focus-visible {
      outline-color: $color-depot;
      border-radius: 0px;
    }

   &:focus-within {
      outline-color: $color-depot;
      border-radius: 0px !important;
    }
   &/deep/:focus {
      outline-color: $color-depot;
      border-radius: 0px !important;
    }
   &:active {
      outline-color: $color-depot;
      border-radius: 0px;
    }
   &:target {
      outline-color: $color-depot;
      border-radius: 0px;
    }

  }
  .otp-input::-webkit-inner-spin-button,
  .otp-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .ERROR-ICON {
  top: 4px;
  position: relative;
  line-height: 18px;
  padding: 4px;
  font-size: 12px;
  background-color: $color-red;
  color: white;
}
</style>
